import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'; 
import { Lote } from 'src/app/models/lote';
import { LoteService } from 'src/app/services/lote.service';

@Component({
  selector: 'app-lotesdialog',
  templateUrl: './lotesdialog.component.html',
  styleUrls: ['./lotesdialog.component.css']
})
export class LotesdialogComponent implements OnInit {
  listadolote : Lote[] = []; 
  idempresa = "";
  idprecompra = "";


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<LotesdialogComponent>,
    private loteService: LoteService
  ) { }

  ngOnInit() {
    console.log ('dato', this.data);

    
    if (Object.keys(this.data).length != 0) {
    this.idempresa = this.data.identificador.idempresa,
    this.idprecompra = this.data.identificador.idprecompra
    } else
    {
      // este valor es tomado de una empresa se supone que no se repetira nuca
      // este mismo valor se usara para desplegar los lotes de excursion ya que estos nmo tienene identificador 
      // si no que son usados por todos los lander
      this.idempresa = "5fcbc46994dde809f8aab6cc",
      this.idprecompra = "5fcbc46994dde809f8aab6cc"
    }
   
    
    this.despliegalotes(this.idprecompra);

  }

  despliegalotes(idprecompra: string ) {
    this.loteService.muestralote(idprecompra).subscribe(resp => {
      this.listadolote = resp.lote;
    })

    
  }

  miFormulario = new FormGroup({
    numerolote : new FormControl('', Validators.required),
    cantidad : new FormControl('0', Validators.required),
    descripcionlote: new FormControl('', Validators.required)
  })

  

  registrarlote(){
    

    const lote = new Lote(
    this.idempresa,
    this.idprecompra,
    this.miFormulario.get("numerolote").value,
    this.miFormulario.get("descripcionlote").value,
    this.miFormulario.get("cantidad").value,
    null,
    false

      );

    

   this.loteService.crearlote(lote) 
      .subscribe ( resp => {
        this.miFormulario.reset();
     
        this.listadolote = resp.lote;

      });
   }


   closeDialog() {
    this.dialogRef.close();
  
    }

}

